import Axios from "axios";
import { SETTINGS } from "../../properties/ApiProps";

export const LoginRepository = {
  createUser: (user, recaptcha) => {
    return Axios({
      url: SETTINGS.API_URL + "users/register",
      method: "POST",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: { "g-recaptcha-response": recaptcha },
      data: user,
    });
  },

  verifyUser: (token) => {
    return Axios({
      url: `${SETTINGS.API_URL}users/verify/${token}`,
      method: "POST",
    });
  },

  getResetPasswordLink: (email) => {
    return Axios({
      url: `${SETTINGS.API_URL}users/resetPassword`,
      params: { email: email },
      method: "POST",
    });
  },

  resetPassword: (token, newPassword, recaptcha) => {
    return Axios({
      url: `${SETTINGS.API_URL}users/resetPassword/${token}`,
      params: { newPassword: newPassword, "g-recaptcha-response": recaptcha },
      method: "PUT",
    });
  },
};
